<template>
    <v-content>
        <v-container fluid fill-height>
            <v-row justify="center">
                <v-col cols="12" sm="7" md="4" lg="3">
                    <v-alert
                        v-model="alert.show"
                        dismissible
                        :color="alert.color"
                        :icon="alert.icon"
                        :type="alert.type"
                        transition="scale-transition"
                        class="mb-3"
                    >{{ alert.text }}</v-alert>
                    <div class="login_content">
                        <v-img
                            class="login_image"
                            :src="require('@/assets/logo.svg')"
                            alt="Tasklaw - Software Jurídico"
                            aspect-ratio="2"
                            max-height="140px"
                            contain
                        ></v-img>
                        <v-spacer></v-spacer>
                        <form-login v-if="showFormLogin" :loading="loading" @change-form="changeForm" @login="requestLogin"></form-login>
                        <form-forget-password v-else :loading="loading" @change-form="changeForm" @forget-password="forgetPassword"></form-forget-password>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-content>
</template>

<script>
import API from '@/api'
import FormLogin from '@/components/Login/FormLogin.vue'
import FormForgetPassword from '@/components/Login/FormForgetPassword.vue'

export default {
    name: 'login-layout',
    components: {
        FormLogin,
        FormForgetPassword
    },
    data: () => ({
        loading: false,
        showFormLogin: true,
        alert: {
            show: false,
            color: undefined,
            icon: undefined,
            type: undefined,
            text: undefined
        }
    }),
    methods: {
        showLoading () {
            return !this.loading
        },
        changeForm (boolean) {
            this.showFormLogin = boolean
        },
        requestLogin (params) {
            this.showLoading()
            let endpoint = API.EndPoints.login
            new API(endpoint, params).request().then(async response => {
                this.$helpers.setItemLocalStorage('sessionToken', response.body.sessionToken)

                endpoint = API.EndPoints.me
                const profile = await new API(endpoint, {}).request().then(async response => {
                    return response.body
                }, error => {
                    if (error.status !== 0) this.dispatchAlertError(error.body.error)
                })

                const companies = await this.$helpers.getAllUserCompanies(profile)

                if (companies.length <= 0) {
                    alert('Você não faz parte de nenhuma organização ou departamento, verifque com o seu administrador!')
                    this.requestLogout()
                }

                this.$helpers.setLocalStorage(profile, companies)

                window.getApp.login = true
                if (profile.changedPassword === false) {
                    this.$router.push('/nova_senha').catch(e => {})
                } else {
                    this.$router.push('/demandas').catch(e => {})
                }
            }, error => {
                if (error.status !== 0) this.dispatchAlertError(error.body.error)
            })
        },
        forgetPassword (params) {
            this.showLoading()
            let endpoint = API.EndPoints.requestPasswordReset
            new API(endpoint, params).request().then(response => {
                this.dispatchAlert('green', 'check_circle', 'success', 'Sua requisição foi realizada, verifique o seu email!')
                this.showLoading()
            }, error => {
                if (error.status !== 0) this.dispatchAlertError(error.body.error)
            })
        },
        dispatchAlert (color, icon, type, text) {
            this.alert.show = true
            this.alert.color = color
            this.alert.icon = icon
            this.alert.type = type
            this.alert.text = text
        },
        dispatchAlertError (error) {
            this.$helpers.clearLocalStorage()
            this.dispatchAlert('red', 'warning', 'warning', error)
            this.showLoading()
        },
        requestLogout () {
            let endpoint = API.EndPoints.logout
            new API(endpoint, {}).request()
            this.invalidSession = false
            this.logout = false
            this.login = false
            this.$helpers.clearLocalStorage()
            this.$router.push('/login').catch(e => {})
        }
    }
}
</script>

<style lang="stylus" scoped>
    .login_content
        border-radius: 4px
        background-color: #ffffff

    .login_image
        margin: auto 10px
        border: 1px solid rgba(0, 0, 0, 0)
        border-bottom: none
</style>
